import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { queryParamsMailshot } from './model/mailshot.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MailshotService {
  select = [
    {
      data: this.generateYearOptions(),
      placeholder: 'Buscar año',
      filterType: 'year',
    },
    {
      data: [
        { label: 'Todas', value: null },
        { label: 'Sin descargar', value: false },
        { label: 'Descargadas', value: true },
      ],
      placeholder: 'Selecciona una',
      filterType: 'download',
    },
  ];

  constructor(public api: ApiService) {}

  /**
   * @param startYear Año inicial (por defecto 2020)
   * @returns Array de objetos con label y value para los años
   */
  private generateYearOptions(startYear: number = 2020): Array<{label: string, value: number}> {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push({
        label: year.toString(),
        value: year
      });
    }

    return years;
  }

  //#region MAILSHOT-SERVICE
  public createMailshot(data: any): Observable<any> {
    // crear circular
    return this.api.post(`${environment.API_MAILSHOT_SERVICE}/mailshot`, data);
  }

  public listMailshot(data: queryParamsMailshot): Observable<any> {
    const queryParams = [];

    if (data.page) {
      queryParams.push(`page=${data.page}`);
    }

    if (data.pageSize) {
      queryParams.push(`pagesize=${data.pageSize}`);
    }

    if (data.year) {
      queryParams.push(`year=${data.year}`);
    }

    if (data.isDownload || data.isDownload == false) {
      queryParams.push(`downloadedByUser=${data.isDownload}`);
    }

    if (data.description) {
      queryParams.push(`filter=${data.description}`);
    }

    const queryString =
      queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    const url = `${environment.API_MAILSHOT_SERVICE}/mailshot/me${queryString}`;

    return this.api.get(url);
  }

  public listMailshotAll(data: queryParamsMailshot): Observable<any> {
    const queryParams = [];

    if (data.page) {
      queryParams.push(`page=${data.page}`);
    }

    if (data.pageSize) {
      queryParams.push(`pagesize=${data.pageSize}`);
    }

    if (data.year) {
      queryParams.push(`year=${data.year}`);
    }

    if (data.description) {
      queryParams.push(`filter=${data.description}`);
    }

    const queryString =
      queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    const url = `${environment.API_MAILSHOT_SERVICE}/mailshot${queryString}`;

    return this.api.get(url);
  }

  public getYears(): Observable<any> {
    const url = `${environment.API_MAILSHOT_SERVICE}/mailshot/years`;

    return this.api.get(url);
  }

  public markAsDownloaded(id: number): Observable<any> {
    //Marcar como visto
    return this.api.patch(
      `${environment.API_MAILSHOT_SERVICE}/mailshot/${id}/download/me`
    );
  }

  public getDetailsMailshot(id: number) {
    return this.api.get(`${environment.API_MAILSHOT_SERVICE}/mailshot/${id}`);
  }

  public deleteMailshot(id: any) {
    return this.api.delete(
      `${environment.API_MAILSHOT_SERVICE}/mailshot/${id}`,
      false
    );
  }

  public sendNotifications(data: any, id: any) {
    return this.api.put(
      `${environment.API_MAILSHOT_SERVICE}/mailshot/notify/${id}`,
      data
    );
  }
  //#endregion

  //#region FILE-SERVICE
  getAttachmentById(id: number) {
    return this.api.get(`${environment.API_FILE_SERVICE}/file/${id}`);
  }

  getAllAttachment() {
    //obtener todos los archivos
    return this.api.get(`${environment.API_FILE_SERVICE}/file`);
  }

  createAttachment(data: any) {
    //crear adjunto mandar por form data
    return this.api.post(`${environment.API_FILE_SERVICE}/file`, data);
  }

  getAttachmentByElementId(id: number, type: any, includePublicUrl = true) {
    let params = new HttpParams().set('typeFile', type);
    if (includePublicUrl) {
      params = params.set('includePublicUrl', 'true');
    }
    return this.api.getWithOptions(`${environment.API_FILE_SERVICE}/file/elements/${id}`, { params });
  }

  //#endregion
}
